import {
  LicensingKlasses,
  PlayerSegmentInterface,
  SegmentTypes,
} from '@splixer/common';
import { Uuid } from '@hidat/huijs-common';
import * as dayjs from 'dayjs';
import { Expose, Transform } from 'class-transformer';
import { dayjsTransformer } from '@hidat/huijs-dates';

export class PlayerSegment implements PlayerSegmentInterface {
  @Expose()
  uid: Uuid | undefined;
  @Expose({ name: 'segment_type' })
  segmentType: SegmentTypes | undefined;
  @Expose({ name: 'licensing_klass' })
  licensingKlass: LicensingKlasses | undefined;
  @Expose({ name: 'broadcasted_at' })
  @Transform(dayjsTransformer, { toClassOnly: true })
  broadcastedAt: dayjs.Dayjs | undefined;
  @Expose()
  duration: number | undefined;
  @Expose({ name: 'hour_in_show' })
  hourInShow: number | undefined;
  @Expose()
  name: string | undefined;

  // Keep compiler happy
  id: number | undefined;
  createdAt: dayjs.Dayjs | undefined;
  updatedAt: dayjs.Dayjs | undefined;
}
